import React from "react";
import { List } from "react-content-loader";
import { Box } from "rebass";
export default () => (
    <Box width="50%">
        <List />
    </Box>
);
